<template>
    <div id="searchbox" class="card-body bg-white shadow rounded m-3 mb-5">
		<Transition>
			<div v-if="this.loading" class="col-12 text-center mb-3">
				<div class="modal fade show mt-5" tabindex="-1" role="dialog" id="exampleModal"
					aria-labelledby="exampleModalTitle" style="display: block;" aria-modal="true" data-focus-mouse="false">
					<div class="modal-dialog" role="document">
						<div class="modal-content rounded shadow">
							<div class="modal-body">
								<p><b>Caricamento risultati in corso...</b></p>
								<div class="spinner-grow text-primary mb-3" role="status">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Transition>

		<div class="px-4">
			<div class="mb-2 d-flex">
				<div class="row flex-grow-1">
					<div class="form-group mb-0 mt-5 col-12 col-lg-4">
						<label for="text-search" class="active">Filtra per contenuto:</label>
						<input @change="search" @keyup.enter="search" v-model="searchInput" type="text" class="form-control mb-3"
							id="text-search" name="text-search" placeholder="Ricerca per contenuti">
						<Transition>
							<a v-if="this.searchInput != ''" class="cpointer" @click="clearSearch">
								<svg class="icon icon-sm icon-primary">
									<use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-funnel"'></use>
								</svg>
								Ripristina filtro contenuto
							</a>
						</Transition>
					</div>
					<div class="form-group mb-0 mt-5 col-12 col-lg-4">
						<label for="date-search" class="active">Filtra per data:</label>
						<input @change="search" @keyup.enter="search" v-model="dateInput" class="form-control datepicker mb-3" type="date"
							id="date-search" name="date-search" min="2023-04-01">
						<Transition>
							<a v-if="this.dateInput != ''" class="cpointer" @click="clearDate">
								<svg class="icon icon-sm icon-primary">
									<use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-funnel"'></use>
								</svg>
								Ripristina filtro per data
							</a>
						</Transition>
					</div>
					<div class="form-group mb-0 mt-5 col-12 col-lg-4 select-wrapper">
						<label for="dlgs" class="active">Filtra per validità decreto:</label>
						<select @change="search" @keyup.enter="search" v-model="dlgsInput" name="dlgs" class="select mb-3">
							<option v-for="dlgs in this.$root.dlgs"
								:value="dlgs.end ?? this.currentDateToDlgsValue()" :key="dlgs.id">
								{{ dlgs.title }}
							</option>
						</select>
						<Transition>
							<a class="cpointer" v-if="this.dlgsInput != (new Date()).toISOString().split('T')[0]" @click="clearDlgs">
								<svg class="icon icon-sm icon-primary">
									<use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-funnel"'></use>
								</svg>
								Ripristina validità decreto
							</a>
						</Transition>
					</div>
				</div>
				<div class="d-flex">
					<button type="button" :disabled="this.searchInput == '' && this.dateInput == '' && this.dlgsInput == ''" @click="search"
						class="my-auto btn btn-primary p-3 ms-4 shadow rounded-circle btn-lg">
						<svg class="icon icon icon-white">
							<use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-search"'></use>
						</svg>
					</button>
				</div>
			</div>
		</div>
</div>
</template>

<style>
.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}

.cpointer  {
	cursor: pointer;
}

#searchbox {
	position: sticky;
	top: 100px;
	z-index: 1000;
}

@media (max-width: 992px) {
	#searchbox {
		position: static;
	}
}

</style>

<script>

export default {
	name: "SearchBar",
	data() {
		return {
			searchInput: "",
			dateInput: "",
			dlgsInput: (new Date()).toISOString().split('T')[0],
			loading: false,
			debounceTimer: null,
		}
	},
	props: {
		treeContainer: {
			type: Object,
			required: true
		}
	},
	mounted() {
		// Crea la versione con debounce della funzione search
		this.search = this.debounced(this.performSearch, 500);
		
		this.clearSearch();
        if (this.$root.version) {
            var currentDlgs = this.$root.dlgs.filter((d) => {return d.id == this.$root.version})
            if (currentDlgs.length == 1) {
                currentDlgs = currentDlgs[0]
				if (!currentDlgs.validity_end) {
					currentDlgs.validity_end = this.currentDateToDlgsValue()
				}
                this.dlgsInput = currentDlgs.validity_end
				this.$nextTick(() => this.search())
            }
        }
	},
	watch: {
		dateInput(newVal) {
			if (newVal && newVal < "2023-04-01") {
				// Imposta la data al minimo consentito senza attivare la ricerca
				this.dateInput = "2023-04-01";
			}
		}
	},
	methods: {
		// Funzione per applicare il debounce
		debounced(fn, delay) {
			return (...args) => {
				clearTimeout(this.debounceTimer);
				this.debounceTimer = setTimeout(() => fn.apply(this, args), delay);
			};
		},
		currentDateToDlgsValue() {
			return (new Date()).toISOString().split('T')[0]
		},
		async clearSearch() {
			this.loading = true
			this.searchInput = "";
			if (this.treeContainer.contentTree) {
				this.treeContainer.contentTree.setUnfiltered()
				this.treeContainer.updateContentTree();
			}
			this.loading = false
		},
		async clearDate() {
			this.loading = true
			this.dateInput = "";
			if (this.treeContainer.contentTree) {
				this.treeContainer.contentTree.setUnfiltered()
				this.treeContainer.updateContentTree();
			}
			this.loading = false
		},
		async clearDlgs() {
			this.loading = true
			this.dlgsInput = (new Date()).toISOString().split('T')[0];
			if (this.treeContainer.contentTree) {
				this.treeContainer.contentTree.setUnfiltered()
				this.treeContainer.updateContentTree();
			}
			this.loading = false
		},
		// Funzione originale di ricerca che verrà chiamata con debounce
		async performSearch() { 
			// Non eseguire la ricerca se la data è inferiore al minimo consentito (01/04/2023)
			if (this.dateInput) {
				// Converti le stringhe in oggetti Date per un confronto corretto
				const inputDate = new Date(this.dateInput);
				const minDate = new Date("2023-04-01");
				
				if (inputDate < minDate) {
					// Imposta la data al minimo consentito senza eseguire la ricerca
					this.dateInput = "2023-04-01";
					return;
				}
			}
			if (!this.searchInput && !this.dateInput && !this.dlgsInput) { //se non è attivo nessun input di ricerca pulisci i filtri
				this.clearSearch();
				return;
			}
			const response = await fetch(this.$root.config.VUE_APP_BACKOFFICE_URL + '/articles?search=' + this.searchInput + '&date=' + this.dateInput + '&dlgs=' + this.dlgsInput)
			if (response.ok) {
				const results = await response.json()
				if (results.status == "success") {
					this.treeContainer.contentTree.filterBySearchResults(results.data)
				}
				this.treeContainer.updateContentTree()
				this.loading = false
				//TODO: gestisci l'errore
			}
		}
	}
}
</script>